import type { Maybe } from 'src/types';
import { VisibilityLevel } from 'src/types/graphql';

export const showApproachability = (
  profileVisibilityLevel: Maybe<VisibilityLevel>,
) =>
  profileVisibilityLevel !== VisibilityLevel.Hidden &&
  profileVisibilityLevel !== null;
